import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import Button from '@components/uikit/Button/Button';
import ChatLabel from '@components/uikit/ChatLabel/ChatLabel';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  alertTooltipId: string;
  pointInfo: { id: number; label: string; facilityId?: number; facilityOffset?: number };
  regularAiId?: number;
}

const ChartAlertTooltip: React.FC<IProps> = ({ alertTooltipId, pointInfo, regularAiId }) => {
  const { t } = useTranslation();

  const { customerId } = useParams();
  const { pathname } = useLocation();

  const { setActiveModal } = useModalActions();

  return (
    <Tooltip
      id={alertTooltipId}
      float={true}
      place="bottom"
      className={style.alertTooltip}
      clickable
      disableStyleInjection
      render={({ content }) => {
        if (!content) {
          return null;
        }

        const alertCondition = JSON.parse(content);

        return (
          <>
            <div className={style.tooltipTitle}>{t('Automatic Action Item')}</div>
            <div className={style.tooltipBody}>
              <div className={style.alertInfo}>
                {t('Alert Level')}
                <ChatLabel
                  text={t(alertCondition?.alertLevelName)}
                  variant={alertCondition?.alertLevelName.toLowerCase()}
                />
              </div>
              <div className={style.alertInfo}>
                {t('Value')}
                <span className={style.alertInfoValue}>
                  {alertCondition?.value || '-'} {alertCondition?.chartUnit}
                </span>
              </div>
              <div className={style.alertInfo}>
                {t('Trigger Time')}
                <span className={style.alertInfoValue}>
                  {alertCondition?.triggerTime} {t('min')}
                </span>
              </div>
              <div className={style.tooltipInfo}>
                {t(
                  regularAiId
                    ? 'To request an adjustment to automatic action item settings, please leave a comment in the'
                    : 'To request an adjustment to automatic action item settings, please',
                )}
              </div>
              {regularAiId ? (
                <Link
                  className={style.tooltipLink}
                  to={`/customer/${customerId}/ai/${regularAiId}`}
                  state={{ prevPage: pathname }}
                >
                  {t('existing action item')}
                </Link>
              ) : (
                <Button
                  type="secondary"
                  text={t('create an action item')}
                  className={style.tooltipBtn}
                  onClick={() =>
                    setActiveModal({
                      name: MODAL_NAMES.addActionItemModal,
                      options: {
                        filledData: {
                          option: 'requestInvestigation',
                          aiType: 'regular',
                          installationPoint: pointInfo,
                          urgency: alertCondition?.alertLevelName,
                          currentStep: 3,
                        },
                      },
                    })
                  }
                />
              )}
            </div>
          </>
        );
      }}
    />
  );
};

export default ChartAlertTooltip;
